import React from 'react';
import PropTypes from 'prop-types';
import * as styles from './Button.module.css';

/**
 * Button - A reusable button component with consistent styling
 * Supports different variants, sizes, and states
 */
function Button({
  children,
  variant = 'primary',
  size = 'medium',
  disabled = false,
  loading = false,
  fullWidth = false,
  buttonType = 'button',
  onClick,
  className = '',
  ...props
}) {
  const buttonClass = [
    styles.button,
    styles[variant],
    styles[size],
    fullWidth && styles.fullWidth,
    disabled && styles.disabled,
    loading && styles.loading,
    className,
  ]
    .filter(Boolean)
    .join(' ');
  
  return (
    <button
      type={buttonType === 'submit' ? 'submit' : 'button'}
      className={buttonClass}
      onClick={onClick}
      disabled={disabled || loading}
      data-testid={props['data-testid']}
      title={props.title}
      aria-label={props['aria-label']}
    >
      {loading && (
        <span className={styles.spinner}>
          <svg viewBox="0 0 24 24" fill="none">
            <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="3" opacity="0.25" />
            <path
              d="M12 2 A10 10 0 0 1 22 12"
              stroke="currentColor"
              strokeWidth="3"
              strokeLinecap="round"
            />
          </svg>
        </span>
      )}
      <span className={styles.content}>{children}</span>
    </button>
  );
}

  Button.propTypes = {
  children: PropTypes.node.isRequired,
  variant: PropTypes.oneOf(['primary', 'secondary', 'danger', 'success', 'outline']),
  size: PropTypes.oneOf(['small', 'medium', 'large']),
  disabled: PropTypes.bool,
  loading: PropTypes.bool,
  fullWidth: PropTypes.bool,
  buttonType: PropTypes.oneOf(['button', 'submit', 'reset']),
  onClick: PropTypes.func,
  className: PropTypes.string,
};

Button.defaultProps = {
  variant: 'primary',
  size: 'medium',
  disabled: false,
  loading: false,
  fullWidth: false,
  buttonType: 'button',
  onClick: undefined,
  className: '',
};

export default Button;

